import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT, TYPE_DATASOURCE } from 'src/app/app.models';
import { COMPONENT_MODE, COMPONENT_UI } from '../workflow-components.models';
import { WorkflowComponentBuilderOptions } from '../workflow-components.service';

export class Model_TemplateDocument {
    ID: string;
    ZONES: Zone[];
    NOM: string;
    FILE_TEMPLATE: any;
    ZONE_MARQUEUR: Zone;
    TEXT_MARQUEUR: string[];

    constructor(template?) {
        template = template || {};
        this.ID = template.ID || '';
        this.NOM = template.NOM || '';
        this.FILE_TEMPLATE = template.FILE_TEMPLATE || '';
        this.ZONES = template.ZONES || [];
        this.TEXT_MARQUEUR = template.TEXT_MARQUEUR || [];
    }
}

export class Zone {
    x: number;
    y: number;
    h: number;
    w: number;
    NOM: string;
    TYPE: Enum_TypeDonnee;

    constructor(zone?) {
        zone = zone || {};
        this.x = zone.x || 0;
        this.y = zone.y || 0;
        this.w = zone.w || 0;
        this.h = zone.h || 0;
        this.TYPE = zone.TYPE || Enum_TypeDonnee.STRING;
        this.NOM = zone.NOM || '';
    }
}

export enum Enum_TypeDonnee {
    NUMERIC = 0,
    STRING = 1,
    DATE = 2
}
  
export interface GedDesignerModelConfig extends DynamicInputModelConfig {
}
  
export class GedDesignerModel extends DynamicInputModel {
	@serializable() readonly type: string = 'ged_designer';
	componentMode: COMPONENT_MODE;
	componentUI: COMPONENT_UI;

	constructor(config: GedDesignerModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
	}

	static initModel(_component: Model_WorkflowComponent): GedDesignerModel {
		const formModel = new GedDesignerModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			additional: _component,
			relations: _component.RELATIONS
		});
		return formModel;
	}

	static getProperties(_options?: WorkflowComponentBuilderOptions): Model_WorkflowComponent {
		return {
			ID: 'ged',
			CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX,
			ICON: 'create-outline',
			LABEL: 'Ged',
			PROPERTIES: [
				{ ID: 'GUID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'GUID', IS_VISIBLE: false },
				{ ID: 'INDEX', CODE: CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index', DEFAULT_VALUE: 1 },
				{ ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Identifiant', IS_REQUIRED: true, CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }] },
				{ ID: 'LABEL', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Libellé', IS_REQUIRED: true },
				{ ID: 'INPUT_TYPE', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Type', DEFAULT_VALUE: 'text', IS_REQUIRED: true, 
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [{ ID: 'text', TEXT: 'Texte' }, { ID: 'date', TEXT: 'Date' }],
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					}
				},
				{ ID: 'IS_VISIBLE', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Visible ?', DEFAULT_VALUE: true },
				{ ID: 'IS_REQUIRED', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Requis ?' },
			]
		};
	}
}
  